module.exports = __webpack_public_path__ + "static/img/NI.15abc0c9.svg";